import { useEffect } from 'react';
import { InfiniteQueryObserverResult } from 'react-query';
import { useSlidePanelShallowStore } from '@frontend/slide-panel';
import { VoicemailInfiniteQueryData } from '../all-calls/types';
import { TranscriptionContext } from '../voicemail-details/types';

export const useSyncDetailsPanel = ({
  shouldSync,
  instanceId,
  toggleRowSelected,
  getNextPage,
  markCurrentRowSelected,
}: {
  shouldSync: boolean;
  instanceId: string;
  toggleRowSelected: (id: string, set: boolean, index?: number) => void;
  getNextPage?: () => Promise<InfiniteQueryObserverResult<VoicemailInfiniteQueryData, unknown>>;
  markCurrentRowSelected: () => void;
}) => {
  const { show, panelType, context, setShow } = useSlidePanelShallowStore<TranscriptionContext>(
    'setShow',
    'context',
    'panelType',
    'show'
  );

  useEffect(() => {
    /**
     * This effect is to update the slide panel context with the new rows from the new table instance when the table instance changes.
     * The table instance will change if the user navigates away from the voicemail table, while having the transcription panel open.
     *
     * If we don't do this, each row's `toggleRowSelected` will not work as expected, since they are tied to the stale table instance.
     */
    if (show && panelType === 'voicemailTranscription' && shouldSync) {
      markCurrentRowSelected();
      if (context) {
        setShow(true, 'voicemailTranscription', {
          ...context,
          getNextPage,
          instanceId,
          toggleRowSelected,
        });
      }
    }
  }, [
    show,
    panelType,
    context,
    setShow,
    shouldSync,
    markCurrentRowSelected,
    instanceId,
    toggleRowSelected,
    getNextPage,
  ]);
};
